import React, { useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import {
  NavPills,
  NavPillsOrientation
} from "../../../../generic-shared-components/components"
import { LinkType } from ".."
import { disableRedirect } from "./helpers"

interface ModuleTabs {
  activePage?: LinkType
  module?: string
  id?: string
  orientation?: NavPillsOrientation
}

const ModuleTabs: React.FC<React.PropsWithChildren<ModuleTabs>> = props => {
  const { activePage, module, orientation, id } = props

  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (activePage?.children?.length && !module) {
      const initialTab = activePage?.children[0]

      if (
        initialTab.url &&
        initialTab.url !== location.pathname &&
        disableRedirect(activePage)
      ) {
        history.replace(initialTab.url)
      }
    }
  }, [activePage?.key, module, location?.search])

  const getForceTabs = () => {
    if (activePage?.key === "author") {
      return [
        {
          key: "content",
          name: "Content",
          url: `/snap/author/mastery-lessons`,
          selected: true
        }
      ]
    }

    return []
  }

  const forceTabs = getForceTabs()

  const itemsWithUrl = (
    forceTabs.length ? forceTabs : (activePage?.children as any[])
  )?.filter(item => item.url)

  const selectedTab =
    forceTabs?.find(item => item.selected)?.key || module || ""

  const tabsItems =
    itemsWithUrl?.map(item => ({
      label: item.name,
      value: item.key,
      href: item.url
    })) || []

  return (
    <>
      {!!(activePage?.children?.length || forceTabs.length) && (
        <NavPills
          size="lg"
          id={id}
          mode="dark"
          orientation={orientation}
          items={tabsItems}
          value={selectedTab}
          component="div"
        />
      )}
    </>
  )
}

export default ModuleTabs
